<app-shared-dialog
  [options]="{
    confirmText: 'common.confirm' | translate,
    confirmButtonStyle: 'danger',
    cancelText: 'common.cancel' | translate,
    hideHeader: true,
    confirmLoading: isLoading,
    disableConfirm: isLoading,
    size: 'medium'
  }"
  (confirm)="confirm()"
  (cancel)="cancel()"
>
  <div class="kb-confirmation-dialog">
    <span class="kb-confirmation-dialog__icon">
      <ui-svg-icon [svgIcon]="icon" size="large"></ui-svg-icon>
    </span>
    <span class="kb-confirmation-dialog__title">{{ title }}</span>
    <p class="kb-confirmation-dialog__description">{{ description }}</p>
  </div>
</app-shared-dialog>
